import React from 'react';
import { Link } from 'react-router-dom';
import CreateSotSwitcher from './CreateSotSwitcher';
import JobsSotSwitcher from './JobsSotSwitcher';
import TrueEmptySwitcher from './TrueEmptySwitcher';
import { SHOP_CREATE_SOT_NOTICE, SHOP_TRUE_EMPTY_SOT_NOTICE } from './createShopJob';
import { SHOP_JOBS_SOT_NOTICE } from './jobsSurface';

const DevJobsSotPage = () => (
    <div className="container w-full mx-auto pt-20" data-testid="jobs-sot-dev">
        <div className="flex flex-col items-center mt-10 px-6">
            <div className="status-empty-card w-10/12 mb-6">
                <p className="status-empty-eyebrow">JOBS · SOT</p>
                <h2>Prove empty / error / offline on Hosting</h2>
                <p>
                    Hosting production ignores <code>?jobsPreview=</code>. These
                    links open <code>/app/jobs?jobsSot=</code> so AJ can prove{' '}
                    <strong>JOBS · EMPTY</strong>, <strong>JOBS · ERROR</strong>,{' '}
                    <strong>JOBS · OFFLINE</strong>,{' '}
                    <strong>PENDING · EMPTY</strong>,{' '}
                    <strong>PENDING · HANDOFF</strong>,{' '}
                    <strong>HANDOFF · ACTIVE</strong>, and{' '}
                    <strong>COMPLETE · HANDOFF</strong> without a zero-job shop.{' '}
                    <code>fetchShopJobsWithTechs</code> does not run. Auto World
                    ready list is unchanged without the query.{' '}
                    <strong>Create job</strong> from <strong>JOBS · EMPTY</strong>{' '}
                    is paint-only <strong>CREATE · SOT</strong> — no confirm,{' '}
                    <code>createShopJob</code> does not run. That is not the
                    true-empty live write. Glass only — never ADAS.
                </p>
                <JobsSotSwitcher />
                <p className="status-empty-note">{SHOP_JOBS_SOT_NOTICE}</p>
                <Link className="status-empty-cta" to="/app/jobs">
                    Open live Auto World list
                </Link>
            </div>
            <div className="status-empty-card w-10/12 mb-6" data-testid="true-empty-dev">
                <p className="status-empty-eyebrow">TRUE EMPTY · WALK</p>
                <h2>Prove confirm → createShopJob without emptying Auto World</h2>
                <p>
                    Hosting production ignores <code>?trueEmptyPreview=</code>.
                    This link opens <code>/app/jobs?trueEmptySot=walk</code> so AJ
                    can walk the true-empty <strong>confirm → createShopJob</strong>{' '}
                    path without a zero-job shop. Submit shows the confirm dialog.{' '}
                    <code>createShopJob</code> does not run. Auto World is
                    unchanged. On a real zero-job shop the same confirm writes
                    pending only. This is not <strong>CREATE · SOT</strong>. Glass
                    only — never ADAS.
                </p>
                <TrueEmptySwitcher />
                <p className="status-empty-note">{SHOP_TRUE_EMPTY_SOT_NOTICE}</p>
            </div>
            <div className="status-empty-card w-10/12 mb-6" data-testid="create-sot-dev">
                <p className="status-empty-eyebrow">CREATE · SOT</p>
                <h2>Prove create error / offline / denied on Hosting</h2>
                <p>
                    Hosting production ignores <code>?createPreview=</code>. These
                    links open <code>/app/jobs?createSot=</code> so AJ can prove{' '}
                    <strong>CREATE · ERROR</strong>, <strong>CREATE · OFFLINE</strong>,
                    <strong>CREATE · DENIED</strong>, and{' '}
                    <strong>CREATE · PENDING</strong> without emptying Auto World
                    or calling <code>createShopJob</code>. The create modal opens
                    on the helper card. <strong>CREATE · SOT</strong> from{' '}
                    <strong>JOBS · EMPTY</strong> stays paint-only — no confirm —
                    on submit. Glass only — never ADAS.
                </p>
                <CreateSotSwitcher />
                <p className="status-empty-note">{SHOP_CREATE_SOT_NOTICE}</p>
            </div>
        </div>
    </div>
);

export default DevJobsSotPage;
